import { DatalayerZone } from "@omnia/shared/layers/datalayerZone";
import { INutrientAppZone } from "../types";
import { Datalayer } from "@omnia/shared/layers/datalayer";
import { isNumber } from "@omnia/shared/utils/utils";
import { ol_Feature } from "@omnia/exports/openlayers";

export class NutrientAppZone extends DatalayerZone {

    private _resetProductRate: boolean;
    private _productRate: number;
    private _nutrientRate: number;

    constructor(_layer: Datalayer, protected _appZone: INutrientAppZone, _feature?: ol_Feature) {
        super(_layer, _appZone, _feature);
        this._productRate = _appZone.ProductRate;
        this._nutrientRate = _appZone.NutrientRate;
    }

    get appZone() {
        return this._appZone;
    }

    get productRate() {
        return this._productRate;
    }

    set productRate(value: number) {
        this._productRate = value;
        this.value = value;
    }

    get nutrientRate() {
        return this._nutrientRate;
    }

    setValues(productRate: number, nutrientRate: number) {
        this._productRate = productRate;
        this._nutrientRate = nutrientRate;
    }

    resetToLayerValues() {
        this._productRate = this._appZone.ProductRate;
        this._nutrientRate = this._appZone.NutrientRate;
    }

    hasProductRateChanged() {
        return this.resetProductRate || (this._productRate != this._appZone.ProductRate);
    }

    get resetProductRate(): boolean {
        return this._resetProductRate;
    }

    set resetProductRate(value: boolean) {
        if (value != this._resetProductRate) {
            this._resetProductRate = value;
            if (value) {
                this.value = isNumber(this._appZone.InitProductRate) ? this._appZone.InitProductRate : this._appZone.ProductRate;
                this._productRate = this.value;
            }
        }
    }

    hasUserDefinedProductRate(): boolean {

        let appZone = this._appZone;

        if (appZone) {
            if (appZone.UserDefined) return true;
        }

    }


    getCalculatedRate(): number {

        let appZone = this._appZone;

        if (appZone) {
            return isNumber(appZone.InitProductRate) ? appZone.InitProductRate : appZone.ProductRate;
        }

    }

}
